/* eslint-disable
    import/default,
    import/no-named-as-default-member,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
import * as ResourcesConstants from 'constants/ResourcesConstants'
import { encodeQueryData, getAuthorizationHeader, RequestContentType } from 'utils/Helpers'

const CampaignAPI = Marty.createStateSource({
  id: 'CampaignAPI',
  type: 'http',
  baseUrl: ResourcesConstants.CONVERSATION_API,

  createCampaign(body) {
    return this.post({
      url: '/campaigns',
      contentType: RequestContentType.JSON,
      headers: getAuthorizationHeader(),
      body: JSON.stringify(body)
    })
  },

  getCampaignsForSegment(segmentId) {
    return this.get({
      url: `/user_lists/${ segmentId }/campaigns`,
      headers: getAuthorizationHeader()
    })
  },

  updateCampaign(id, operations) {
    return this.patch({
      url: `/campaigns/${ id }/patch`,
      headers: getAuthorizationHeader(),
      contentType: RequestContentType.JSON,
      body: JSON.stringify(operations)
    })
  },

  // Temporary endpoint that preserves legacy functionality
  updateCampaignOld(id, operations) {
    return this.patch({
      url: `/campaigns/${ id }/old`,
      headers: getAuthorizationHeader(),
      contentType: RequestContentType.JSON,
      body: JSON.stringify(operations)
    })
  },

  fetchCampaigns() {
    return this.get({
      url: '/campaigns?size=500&no_results=true',
      headers: getAuthorizationHeader()
    })
  },

  fetchCampaign(id, accessToken = null) {
    return this.get({
      url: `/campaigns/${ id }`,
      headers: getAuthorizationHeader(accessToken)
    })
  },

  fetchCampaignsForEndUserId(endUserId) {
    return this.get({
      url: `/campaigns?endUserId=${ endUserId }`,
      headers: getAuthorizationHeader()
    })
  },

  fetchLatestCampaignStats(size, type) {
    return this.get({
      url: `/campaigns/latest?${ encodeQueryData({ size, type }) }`,
      headers: getAuthorizationHeader()
    })
  },

  fetchCampaignResults(campaignId, query) {
    return this.get({
      url: `/campaigns/${ campaignId }/results${ encodeQueryData(query) }`,
      headers: getAuthorizationHeader()
    })
  },

  fetchCampaignMembers(campaignId, query) {
    return this.get({
      url: `/campaigns/${ campaignId }/members2?${ encodeQueryData(query) }`,
      headers: getAuthorizationHeader()
    })
  },

  sendTestCampaign(campaign, emails) {
    return this.post({
      url: '/campaigns/test',
      contentType: RequestContentType.JSON,
      headers: getAuthorizationHeader(),
      body: JSON.stringify({ campaign, emails })
    })
  }
})

export default CampaignAPI



// WEBPACK FOOTER //
// ./src/scripts/sources/CampaignAPI.js